module.exports = __webpack_public_path__ + "media/images/mobile-only/mobileonly-copyright-logo-142b77cc89066a7e5201872b673ddb9f.png";